// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tWZ5t","fullView":"styles_fullView__ogPAB"};